import {
    ChangeDetectionStrategy,
    Component,
    ContentChild,
    EventEmitter,
    Input,
    Output,
    TemplateRef,
    ViewEncapsulation,
} from '@angular/core';
import { IItemsListAction2 } from '../fi-items-list/fi-items-list';
import { IReportWidget } from './fi-report-widget';
import { IPeriodDateRange } from '../fi-time-range-menu/fi-time-range-menu';
import { INameIdObj } from '../fi-shared-interfaces';

@Component({
    selector: 'fi-report-widget',
    templateUrl: './fi-report-widget.component.html',
    styleUrls: ['./fi-report-widget.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-report-widget' },
    standalone: false,
})
export class FiReportWidgetComponent<ActionT> {
    @Input() actionsValue: ActionT;
    @Input() actions: IItemsListAction2<ActionT>[] = [];
    @Input() reportName: string = '';
    @Input() widgets: IReportWidget[] = [];
    @Input() isCustomReportWidgetContent: boolean = false;
    @Input() loading: boolean = false;
    @Input() showTimeRangeMenu: boolean = false;
    @Input() showWidgetMenu: boolean = true;
    @Input() showWidgetHeaderButton: boolean = true;
    @Input() timeRangeTooltipText: string;
    @Input() tooltipClass: string;
    @Output() showWidgetDetails = new EventEmitter<boolean>();

    @Input() periodDateRange: IPeriodDateRange<any>;
    @Output() periodDateRangeChange = new EventEmitter<IPeriodDateRange<any>>();
    @Input() timeIntervalOptions: INameIdObj[];
    @Input() isTimeRangeMenuLayout: boolean;
    @Input() customDateRangeValue: number;

    @ContentChild('widgetTemplate') widgetTemplateRef: TemplateRef<{ $implicit: IReportWidget }>;

    protected onShowWidgetDetails(openFilter: boolean) {
        this.showWidgetDetails.emit(openFilter);
    }

    protected onPeriodDateRangeChange(periodDateRange: IPeriodDateRange<any>) {
        this.periodDateRangeChange.emit(periodDateRange);
    }

    protected isWidgetVisible(widget: IReportWidget) {
        return !widget.isHidden || !widget.isHidden();
    }
}
